export default __webpack_public_path__ + "static/media/Icon menu My Numbers_ _ Active.232cc755.svg";